import { Simulator } from "Models";
import { toast } from "react-hot-toast";
import { getAllSimulatorsByFacilityId } from "modules/simulators";
import { useMemo } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { useSelector } from "react-redux";
import { RootState } from "StoreTypes";
import SimulatorDetailsModal from "./SimulatorDetailsModal";
import { useAllFacilities } from "modules/facilities/facilityHooks";
import DeleteSimulatorConfirmationModal from "./DeleteSimulatorConfirmationModal";


type OwnProps = {
  facilityId: string;
};

const SimulatorsTable: React.FC<OwnProps> = ({ facilityId }) => {
  useAllFacilities();

  const CopyIcon: React.FC = () => {
    return (
    <span className="p-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="#798385">
      <path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l58.5 58.5c3 3 4.7 7.1 4.7 11.3L400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-197.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-48 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l16 0 0-48-16 0z"/>
      </svg>
      </span>
      );
  }

  const facilitySimulators = useSelector((state: RootState) =>
    getAllSimulatorsByFacilityId(state, facilityId)
  );
  const columns: TableColumn<Simulator>[] = useMemo(
    () => [
      {
        name: "ID",
        selector: (row) => row.id,
      },
      {
        name: "Name",
        selector: (row) => row.name,
      },
      {
        name: "IoT Access Key",
        selector: (row) => row.ioTAccessKey,
        button: true,
        cell: row => (
          <button className="border-0 bg-transparent text-gray-500 d-flex align-items-center cursor-pointer"
          onClick={() => copyToClipboard(row?.ioTAccessKey)}>
            <span className="d-inline-block text-truncate " style={{maxWidth: '100px'}}>
              {row?.ioTAccessKey} 
            </span>
            <CopyIcon />
          </button>
        ),
        allowOverflow: false,
      },
      {
        name: "Caddy Version",
        selector: (row) => row.caddyVersion,
      },
      {
        name: "Online Install Id",
        selector: (row) => row.installId,
      },
      {
        cell: (sim) => (
          <DeleteSimulatorConfirmationModal
            facilityId={facilityId}
            simulatorId={sim.id}
          />
        ),
        ignoreRowClick: true,
        button: true,
        allowOverflow: true,
      },
      {
        cell: (sim) => <SimulatorDetailsModal simulator={sim} />,
        ignoreRowClick: true,
        button: true,
        allowOverflow: true,
      },
    ],
    [facilityId]
  );

  async function copyToClipboard(text: string) {
    await navigator.clipboard.writeText(text);
    toast.success(`${text} copied to clipboard!`, { position: "bottom-left", style: {
      width: '500px',
      maxWidth: 'none',
    } });
  }

  return (
    <>
    <DataTable
      title='Simulators'
      columns={columns}
      data={facilitySimulators}
      dense
      highlightOnHover
      pagination
      responsive
    />
    </>
  );
};

export default SimulatorsTable;
